export default __webpack_public_path__ + "static/media/panel-indicator.612ab48a.svg";